import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Home from 'containers/home'
import Layout from '../components/layout/index'
import { inject, observer } from 'mobx-react'

@inject('authStore')
@observer
class HomePage extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired
  }

  render () {
    const data = this.props.data.markdownRemark.frontmatter
    return (
      <Layout>
        <Home {...data} />
      </Layout>
    )
  }
}

export default HomePage

export const homePageQuery = graphql`
  query HomePage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        heroUnit {
          heading
          content
          button {
            text
            link
          }
        }
        convenient {
          text1
          text2
          text3
        }
        improveYourKnowledge {
          heading
          button {
            text
            link
          }
        }
        personalize {
          heading
          button {
            text
            link
          }
          item1 {
            icon {
              publicURL
            }
            text
          }
          item2 {
            icon {
              publicURL
            }
            text
          }
          item3 {
            icon {
              publicURL
            }
            text
          }
          item4 {
            icon {
              publicURL
            }
            text
          }
        }
        statistic {
          heading
          items {
            icon {
              publicURL
            }
            value
            label
          }
        }
        getStarted {
          heading
          button {
            text
            link
          }
        }
      }
    }
  }
`
